export default "<h6 class=\"section-label\">{{ to.label }}</h6>\r\n<hr class=\"section-hr\">\r\n"